<template>
  <v-form ref="form"
          lazy-validation
          @submit.prevent="login"
          class="mt-3">
    <v-alert color="error"
             icon="warning"
             value="true"
             v-if="loginError"
             role="alert"
             aria-atomic="true">
      {{$t('login.failed')}}
    </v-alert>
    <v-text-field autofocus
                  name="username"
                  :label="$t('login.username')"
                  :aria-label="$t('login.username')"
                  :id="idPrefix + 'username'"
                  v-model="username"
                  required
                  hide-details
                  :rules="requiredRule" />
    <div class="input-group__details">
      <div class="input-group__messages input-group__error"
           role="alert" aria-atomic="true"
           v-if="username.length === 0 && clickingLogin">
        {{ $t('field_required') }}
      </div>
    </div>
    <v-text-field name="password"
                  :label="$t('login.password')"
                  :aria-label="$t('login.password')"
                  :id="idPrefix + 'password'" type="password"
                  @keyup.enter="login"
                  v-model="password"
                  required
                  hide-details
                  :rules="requiredRule" />
    <div class="input-group__details">
      <div class="input-group__messages input-group__error"
           role="alert" aria-atomic="true"
           v-if="password.length === 0 && clickingLogin">
        {{ $t('field_required') }}
      </div>
    </div>
    <v-btn :id="idPrefix + 'login-button'"
           block dark
           :aria-label="$t('accessible.login_button')"
           color="primary"
           type="submit"
           role="button"
           class="mt-3"
           :loading="loading">
      {{$t('login.login_button')}}
    </v-btn>
  </v-form>
</template>

<script>
import * as actionTypes from '../../store/action-types'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'LoginPanel',
  props: ['idPrefix'],
  data () {
    return {
      username: '',
      password: '',
      startingLogin: false,
      clickingLogin: false,
      requiredRule: []
    }
  },
  computed: {
    ...mapState({
      loading: state => state.profile.loading,
      loggedInUsername: state => state.profile.username,
      loginError: state => state.profile.loginError,
      categories: state => state.intervention.categories
    })
  },
  watch: {
    loggedInUsername (name) {
      // Multiple login panels (page and modal), both will be watching
      if (name && this.startingLogin) {
        this.startingLogin = false
        if (this.categories.length === 0) { // load values if not yet loaded
          this.$store.dispatch(actionTypes.GET_DROPDOWN_VALUES)
        }
        this.fetchAnnouncements()
        this.$emit('logged-in')
      }
    }
  },
  methods: {
    login () {
      this.requiredRule = [
        v => (v ? !!v.trim() : !!v) || this.$t('field_required')
      ]
      setTimeout(() => {
        this.clickingLogin = false
        if (this.$refs.form.validate()) {
          this.startingLogin = true
          let credentials = { username: this.username, password: this.password }
          this.doLogin(credentials)
        } else {
          this.clickingLogin = true
        }
      })
    },
    ...mapActions({
      doLogin: actionTypes.LOGIN,
      fetchAnnouncements: actionTypes.FETCH_USER_ANNOUNCEMENTS
    })
  }
}
</script>

<style>
  .input-group__error {
    color: #ff5252;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/LoginPanel.vue